import classnames from 'classnames';
import React from 'react';
import styles from './avatar.module.scss';

export interface AvatarProps {
  url?: string;
  initials?: string;
  className?: string;
  rounded?: boolean;
  backgroundColor?: string;
  cytest?: string;
}

const Avatar = ({
  url,
  initials,
  className,
  backgroundColor,
  rounded = true,
  cytest = 'avatar:avatar',
}: AvatarProps) => (
  // TODO there is no way to get the avatar backgroundColor from talkjs, so we use a static color here
  <div
    data-cy={cytest}
    data-testid="avatar"
    className={classnames(
      styles.avatar,
      { [styles.rounded]: rounded },
      className
    )}
    style={
      url
        ? {}
        : {
            backgroundColor: backgroundColor ? backgroundColor : '#4e7f9e',
            border: '1px solid #4e7f9e',
          }
    }
  >
    {url ? <img src={url} alt="user-avatar" /> : initials}
  </div>
);

export default Avatar;
